import type {ReportRow, RowWarning} from "../types/types.ts";

export const WARNING_TAG_TEXT = "Controleren";

export const WARNING_TAG_EXPLANATION =
    "Deze rekening hoort niet thuis in dit overzicht. De boekingen worden wel getoond — controleer deze rekening.";

export function hasWarnedRows(rows: {warning: RowWarning | null}[]): boolean {
    return rows.some((row) => row.warning !== null);
}

export function warnedRowAncestorIds(rows: Pick<ReportRow, "id" | "parent_id" | "warning">[]): string[] {
    const byId = new Map(rows.map((row) => [row.id, row]));
    const ancestorIds: string[] = [];
    for (const row of rows) {
        if (!row.warning) continue;
        let parentId = row.parent_id;
        while (parentId) {
            ancestorIds.push(parentId);
            parentId = byId.get(parentId)?.parent_id ?? null;
        }
    }
    return ancestorIds;
}
